import FeatureApprovalRating from "../UI/FeatureApprovalRating";
import React from "react";
import {connect} from "react-redux";
import {updateDataStore} from "../../../actions/foundationActions";

const RatingItem = (props) => {
    const top  = !isNaN(props.top) ? props.top : null;
    const bottom  = !isNaN(props.bottom) ? props.bottom : null;
    const left = !isNaN(props.left) ? props.left : null;
    const right = !isNaN(props.right) ? props.right : null;
    //const bgcolor=props.bgcolor ? props.bgcolor : "transparent";

    const ratingStyle = {
        backgroundColor:"rgba(0,0,0,0.8)",
        border:"dashed white 4px",
        borderRadius:20,
        height:26,
        paddingTop:4,
        position:"relative",
        top:top,
        bottom:bottom,
        left:left,
        right:right,
        color:"white",
        paddingLeft:15,
        width:180
    };

    return (
        <div className="ls-l ratingItem" style={ratingStyle} id={props.feature + props.audience}>
            {props.label}
            <FeatureApprovalRating title={props.naytitle} vote={"-1"} audience={props.audience} feature={props.feature} />
            <FeatureApprovalRating title={props.mehtitle} vote={ "0"}  audience={props.audience} feature={props.feature} />
            <FeatureApprovalRating title={props.yeatitle} vote={ "1"}  audience={props.audience} feature={props.feature} />
        </div>
    )
};
/*
<FeatureApprovalRating vote={1} audience={props.audience} feature={props.feature}/>
            <FeatureApprovalRating vote={0} audience={props.audience} feature={props.feature}/>
            <FeatureApprovalRating vote={-1} audience={props.audience} feature={props.feature}/>
 */
const mapStateToProps = (state) =>{
    return {
        appSettings:state.appSettings,
        dataStore:state.dataStore,
        user:state.user
    };
};

export default connect(mapStateToProps,{
    updateDataStore
})(RatingItem);
